import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

const ALERT_CONFIG = [
    { key: "pilihUPT",           title: "UPT belum dipilih",                          type: "danger" },
    { key: "pilihService",       title: "Jenis Layanan Belum Dipilih",                type: "danger" },
    { key: "alasanKosong",       title: "Alasan penolakan wajib diisi",               type: "danger" },
    { key: "fileTooLarge",       title: "Ukuran file maksimal 1MB. Kompres file sebelum upload", type: "danger" },
    { key: "gagalGantiDokumen",  title: "Gagal mengganti dokumen, coba lagi",         type: "danger" },
    { key: "serverError",        title: "Terjadi kesalahan, silakan coba beberapa saat lagi", type: "danger" },
];

const EditAlertManager = ({ alerts, setAlert, onDone }) => {
    return (
        <>
            {ALERT_CONFIG.map(({ key, title, type }) =>
                alerts[key] ? (
                    <SweetAlert
                        key={key}
                        title={title}
                        {...{ [type]: true }}
                        onConfirm={() => setAlert(key, false)}
                        btnSize="sm"
                    />
                ) : null
            )}

            {alerts.dokumenTerganti && (
                <SweetAlert
                    title="Dokumen Berhasil Diganti"
                    success
                    onConfirm={() => setAlert("dokumenTerganti", false)}
                    btnSize="sm"
                >
                    File dokumen lama telah diganti dengan file yang baru diunggah.
                </SweetAlert>
            )}

            {alerts.selesaiEdit && (
                <SweetAlert title="Data Berhasil Diupdate" success onConfirm={onDone} btnSize="sm">
                    Data trader tersimpan. Tidak ada email yang dikirim untuk update ini.
                </SweetAlert>
            )}

            {alerts.selesaiApprove && (
                <SweetAlert title="Permohonan Disetujui" success onConfirm={onDone} btnSize="sm">
                    Data tersimpan dan email persetujuan telah dikirim ke pemohon.
                </SweetAlert>
            )}

            {alerts.selesaiReject && (
                <SweetAlert title="Permohonan Ditolak/Ditunda" warning onConfirm={onDone} btnSize="sm">
                    Data tersimpan dan email penolakan beserta alasan telah dikirim ke pemohon.
                </SweetAlert>
            )}
        </>
    );
};

export default EditAlertManager;